/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Description_Item_1Inputs */

const es_tyc_description_item_1 = /** @type {(inputs: Tyc_Description_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive, Gmail, Google Calendar`)
};

const en_tyc_description_item_1 = /** @type {(inputs: Tyc_Description_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive, Gmail, Google Calendar`)
};

/**
* | output |
* | --- |
* | "Google Drive, Gmail, Google Calendar" |
*
* @param {Tyc_Description_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_description_item_1 = /** @type {((inputs?: Tyc_Description_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Description_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_description_item_1(inputs)
	return en_tyc_description_item_1(inputs)
});
export { tyc_description_item_1 as "tyc.description.item_1" }